<template>
  <div class="view-contanier">
    <div class="header">
      <div class="tab">
        <!-- <span
          v-permissson="'ZDSJTJ'"
          class="tabItem"
          :class="{ active: active === 0 }"
          @click="changeType(0, 'ZDSJTJ')"
        >制单数据统计</span
        > -->
        <span
          v-permissson="'YSTJ'"
          class="tabItem"
          :class="{ active: active === 1 }"
          @click="changeType(1, 'YSTJ')"
        >营收统计</span
        >
        <!-- <span
          v-permissson="'GJTJ'"
          class="tabItem"
          :class="{ active: active === 2 }"
          @click="changeType(2, 'GJTJ')"
        >轨迹统计</span
        > -->
        <!-- <span
          v-permissson="'YDYYBG'"
          class="tabItem"
          :class="{ active: active === 3 }"
          @click="changeType(3, 'YDYYBG')"
        >月度运营报告</span
        > -->
      </div>
    </div>
    <div v-loading="loading" class="data">
      <el-form ref="form" :model="form" label-position="top">
        <div v-if="active === 0" class="radio" style="margin-bottom: 20px;">
          <span>数据类型</span>
          <el-radio-group v-model="type">
            <el-radio :label="0">客服数据</el-radio>
            <!-- <el-radio :label="1">财务数据</el-radio>
            <el-radio :label="2">财务子订单</el-radio> -->
          </el-radio-group>
        </div>
        <el-form-item :label="label">
          <el-date-picker
            v-if="active !== 3"
            v-model="form.date"
            style="width: 320px"
            type="daterange"
            range-separator="-"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            value-format="yyyy-MM-dd"
            unlink-panels
            :picker-options="pickerOptions"
          >
          </el-date-picker>
          <el-date-picker
            v-else
            v-model="form.dateTime"
            style="width: 320px"
            type="date"
            placeholder="截止日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item v-if="type === 2" label="单号">
          <div class="search">
            <el-popover
              ref="popover"
              placement="top"
              class="searchPop"
              title="批量搜索"
              trigger="click"
              width="378"
            >
              <div class="close" @click="closeSearchPanel">
                <i class="el-icon-close"></i>
              </div>
              <base-muti-input
                ref="baseMutiInput"
                v-model="numbers"
                :default="numbers"
              ></base-muti-input>
              <div style="text-align: right; margin: 16px 0 0">
                <el-button size="small" @click="handleEmpty">清空</el-button>
                <div
                  class="sure"
                  @mousedown="handleConfirm"
                >确定</div
                >
              </div>
            </el-popover>
            <el-input
              :value="searchVal"
              placeholder="请输入单号"
              class="input-search"
              style="width: 320px"
              @focus="handleFocus"
            ></el-input>
          </div>
        </el-form-item>
        <div v-if="active === 3" class="radio">
          <span>查询类型</span>
          <el-radio-group v-model="operationsType">
            <el-radio :label="0">外部</el-radio>
            <el-radio :label="1">内部</el-radio>
          </el-radio-group>
        </div>
        <div v-if="active === 3" style="display: flex;justify-content:space-between">
          <div
            v-permissson="'preview'"
            class="derive flex_c_c"
            style="width: 150px;"
            @click="review()"
          >预览</div>
          <div
            v-permissson="'derive_d'"
            class="derive flex_c_c"
            style="width: 150px;"
            @click="deriveDash(active)"
          >导出</div>

        </div>
        <div v-if="active === 3" style="margin-top: 20px;">
          <div
            v-permissson="'email-send'"
            class="derive flex_c_c"
            @click="dialogVisible = true"
          >邮件发送</div>
        </div>
        <div v-if="active === 2" class="radio">
          <span>提单类型</span>
          <el-radio-group v-model="mblType">
            <el-radio :label="10000">所有</el-radio>
            <el-radio :label="0">海运</el-radio>
            <el-radio :label="1">空运</el-radio>
          </el-radio-group>
        </div>
        <div
          v-if="active !== 3"
          v-show="derive"
          :v-permissson="derive"
          class="derive flex_c_c"
          @click="deriveStatistics(active)"
        >导出</div>
      </el-form>
      <EmailSendDialog
        :dialogVisible="dialogVisible"
        :dateTime="form.dateTime"
        @cancel="dialogVisible = false">
      </EmailSendDialog>
    </div>
  </div>
</template>

<script>
import { permissions, getRecentMonthDate, derive } from '@/utils/common'
import { getOperationsReport } from '@/api/home'
import EmailSendDialog from './components/EmailSendDialog.vue'
import dayjs from 'dayjs'
const BaseMutiInput = () => import('@/components/base/BaseMutiInput')
export default {
  name: 'OperatingStatement',
  components: { EmailSendDialog, BaseMutiInput },
  data() {
    return {
      pickerOptions: {
          shortcuts: [{
            text: '最近一周',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 7)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近一个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 30)
              picker.$emit('pick', [start, end])
            }
          }, {
            text: '最近二个月',
            onClick(picker) {
              const end = new Date()
              const start = new Date()
              start.setTime(start.getTime() - 3600 * 1000 * 24 * 60)
              picker.$emit('pick', [start, end])
            }
          }]
        },
      active: 1,
      activeCode: '',
      form: {
        date: [],
        dateTime: ''
      },
      loading: false,
      dialogVisible: false,
      mblType: 10000,
      type: 0,
      operationsType: 0,
      numbers: [],
      searchVal: ''
    }
  },
  computed: {
    derive() {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const presentTab = menu.children.find((a) => a.code === this.activeCode)
      const code = presentTab?.children?.find((a) => a.nameCH === '导出')?.code
      return code || ''
    },
    label() {
      let str = ''
      switch (this.active) {
        case 0 : str = '上传时间'; break
        case 1 : str = '费用日期'; break
        case 2 : str = '出仓日期'; break
        case 3 : str = '费用截止日期(今天之前)'; break
      }
      return str
    }
  },
  created() {
    this.form.date = getRecentMonthDate(1)
    this.form.dateTime = dayjs(new Date()).subtract(1, 'day').format('YYYY-MM-DD')
    // this.form.feeDate = getRecentMonthDate(1)
  },
  mounted() {
    if (!this.$store.state.connect.connect.tabCode) {
      const menuList = this.$store.getters.initRouter
      const menu = permissions(this.$route.meta.code, menuList)
      const codeList = ['YSTJ']
      // const codeList = ['ZDSJTJ', 'YSTJ', 'GJTJ']
      const code = menu.children.find((a) => codeList.includes(a.code)).code
      // this.active = codeList.indexOf(code)
      this.active = 1
      this.activeCode = menu.children[0].code
    }
  },
  methods: {
    changeType(type, code) {
      this.active = type
      this.activeCode = code
    },
    async deriveStatistics() {
      this.loading = true
      const params = {
        startDate: this.form.date[0],
        endDate: this.form.date[1],
        numbers: this.type === 2 ? this.searchVal || undefined : undefined
      }
      if (this.mblType !== 10000) {
        params.mblType = this.mblType
      }
      let url = ''
      let axiosType = 'get'
      switch (this.active) {
        case 0 :
          url = 'orderOnlineStatistics'
          params.type = this.type
          axiosType = 'get'
          break
        case 1 : url = 'revenueStatistics'; axiosType = 'get'; break
        case 2 : url = 'trackStatistics'; axiosType = 'get'; break
      }
      if (this.type === 2) {
        url = 'GetFinancialSubOrders'
        params.type = undefined
        axiosType = 'post'
      }
      await derive(`Analysis/${url}`, axiosType, params)
      this.loading = false
    },
    async review() {
      try {
        const res = await getOperationsReport({
          dateTime: this.form.dateTime,
          type: this.operationsType
        })
        if (res.success) {
          this.$store.commit('DASHBOARD_SET', {
            ...res.data,
            type: this.operationsType
          })
          this.$router.push('/dashboard')
        } else {
          this.$message.error(res.errorMessage)
        }
      } catch (error) {
        console.log(error)
      }
    },
    async deriveDash() {
      this.loading = true
      const params = {
        dateTime: this.form.dateTime,
        type: this.operationsType
      }
      await derive(`OperationsReport/exportOperationsReport`, 'get', params)
      this.loading = false
    },
    handleConfirm() {
      // mousedown 早于 change 执行 所以延时  如果用click则 change后不执行代码
      setTimeout(() => {
      if (this.numbers && this.numbers !== '') {
        this.searchVal = this.numbers.join(',')
      }
      this.$refs.popover.doClose()
    }, 0)
    },
    handleEmpty() {
      this.numbers = ''
      this.searchVal = ''
      this.$refs.baseMutiInput.reset()
      this.$refs.popover.doClose()
    },
    handleFocus() {
      this.$refs.popover.doShow()
    },
    closeSearchPanel() {
      this.handleConfirm()
    }
  }
}
</script>

<style lang="less" scoped>
.view-contanier {
  width: 100%;
  height: 100%;
  box-sizing: border-box;
  overflow: auto;
  .header {
    display: flex;
    align-items: center;
    width: 100%;
    height: 42px;
    background: #FFFFFF;
    border-radius: 5px 5px 5px 5px;
    padding-left: 20px;
    box-sizing: border-box;
    margin-bottom: 10px;
    .tab {
      display: flex;
      align-items: center;
      height: 100%;
    }
    .tabItem {
      display: flex;
      align-items: center;
      height: 100%;
      padding: 0 20px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #999999;
      line-height: 20px;
      cursor: pointer;
      box-sizing: border-box;
    }
    .active {
      color:  rgb(18,88,188);
    }
  }
  .data {
    display: flex;
    justify-content: center;
    width: 100%;
    height: calc(100% - 52px);
    background: #FFFFFF;
    border-radius: 5px 5px 5px 5px;
    padding-top: 80px;
    box-sizing: border-box;
    .derive {
      width: 320px;
      height: 40px;
      background:  rgb(18,88,188);
      border-radius: 4px 4px 4px 4px;
      font-size: 14px;
      font-family: Microsoft YaHei-Regular, Microsoft YaHei;
      font-weight: 400;
      color: #FFFFFF;
      cursor: pointer;
    }
    .radio {
      margin-bottom: 30px;
      span {
        font-size: 14px;
        font-family: Microsoft YaHei, Microsoft YaHei;
        font-weight: 400;
        color: #666666;
        line-height: 20px;
        margin-right: 13px;
      }
    }
    .search {
      position: relative;
      display: flex;
      margin-right: 5px;
      .searchPop {
        /deep/ .el-popover {
          z-index: 9999;
          right: -26px;
          top: 0;
        }
        .close {
          position: absolute;
          top: 6px;
          right: 10px;
          cursor: pointer;
          font-size: 20px;
        }
      }
      .input-search {
        // width: 166px;
        // height: 30px !important;
        /deep/ .el-input__inner {
          // height: 30px;
          border-top-right-radius: 0;
          border-bottom-right-radius: 0;
        }
      }
    }
  }
}
.sure {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #FFF;
  border: 1px solid #DCDFE6;
  color: #606266;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: .1s;
  font-weight: 500;
  padding: 8px 15px;
  font-size: 14px;
  border-radius: 4px;
  color: #FFF;
  background-color: #409EFF;
  border-color: #409EFF;
  margin-left: 10px
}
</style>
